import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { contactDeveloper } from '@common/common';
import { DataService } from '@data/data.service';
import { NotificationService } from '@notification/notification.service';
import { UserDeviceService } from '@services/user-device.service';
import { tryToScrollDown } from '@util/visual-utils';
import { clearPad, resizeCanvas } from '../../../sigpad/sigpad_util';
import SignaturePad from '../../../sigpad/signature_pad';
import { orderDocumentBase } from '../../order-basic';
import { setByDialogHeight } from '../../order-dialog.helper';
import { SpecialDocumentBase } from '../../special-document-base';
import { OrderDialogService } from '../../order-dialog.service';
import { updateCanvasSize } from '../../../image-edit/image-edit-util';
import { getClientRect } from '@util/web-utils';
import { isFunction } from '@util/utils';

@Component({
  selector: 'app-fill-agb-dialog',
  templateUrl: './fill-agb-dialog.component.html',
})
export class FillAgbDialogComponent extends SpecialDocumentBase
  implements OnInit, AfterViewInit {

  signatureStyle: any = {};
  signatureCanvasStyle: any = {};

  signaturePad: SignaturePad | null = null;

  private _signatureCanvas?: ElementRef;
  @ViewChild('signCanvas') set signPad(elem: ElementRef) {
    this._signatureCanvas = elem;
    this.signaturePad = updateCanvasSize(elem);
  }

  private _cnt?: ElementRef;
  @ViewChild('cnt') set contentRef(content: ElementRef) {
    this._cnt = content;
    setByDialogHeight(this._cnt?.nativeElement as HTMLElement);
  }

  constructor(
    public dialogRef: MatDialogRef<FillAgbDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    notificationService: NotificationService,
    private dataService: DataService,
    private userDeviceService: UserDeviceService,
    dialogService: OrderDialogService
  ) {
    super(notificationService);
    const dialogStyle = dialogService.getStylesForDialog('agb', {});
    const signatureStyle = dialogStyle.signature;

    if (signatureStyle) {
      this.signatureStyle = signatureStyle?.pos || this.signatureStyle;
      this.signatureCanvasStyle = signatureStyle?.canvas || this.signatureCanvasStyle;
    }
  }

  ngOnInit(): void {
    this.signUrl = orderDocumentBase(this.dialogData.orderId) + '/agb/sign';
    this.editUrl = orderDocumentBase(this.dialogData.orderId) + '/agb/edit';

    this.deviceSub = this.userDeviceService.change().subscribe((ev: any) => {
      resizeCanvas(this._signatureCanvas?.nativeElement, this.signaturePad);
      setByDialogHeight(this._cnt?.nativeElement as HTMLElement);
    });

    this.requestEditData(
      this.editUrl,
      this.dataService,
      this.notificationService,
      'Problem beim Laden der Daten für AGB'
    );
  }

  ngOnDestroy(): void {
    this.deviceSub.unsubscribe();
  }

  ngAfterViewInit(): void {
    tryToScrollDown(this._cnt?.nativeElement);
  }

  signClose(save: boolean) {
    if (save) {
      const p = this.signaturePad;

      if (!p) {
        this.notificationService.showErrors([
          'Unterschrift konnte nicht gelesen werden. ' + contactDeveloper
        ]);
        return;
      }

      if (p.isEmpty()) {
        this.notificationService.showErrors([
          'Sie habe keine Unterschrift gesetzt',
        ]);
        return;
      }

      const data = p.toDataURL(); // save image as PNG

      const reqData: any = {
        signature: data,
      };

      this.dataService.post(this.signUrl, reqData, {}).subscribe((res: any) => {
        const data = res?.result;
        if (data.success) {
          this.notificationService.showSuccess('AGB gespeichert');
          this.dialogRef.close(data);
        } else {
          this.notificationService.showErrors([data.error]);
        }
      });
    } else {
      this.dialogRef.close(null);
    }
  }

  clear() {
    clearPad(this.signaturePad);
  }

  scrollTop(up: boolean) {
    var elId = up ? 'agb_top' : 'area';
    var el = document.getElementById(elId);
    var contentEl = document.getElementById('agb_content');
    if (el && contentEl) {
      //const elRect = getClientRect(el);
      el.scrollIntoView({
        behavior:'smooth'
      });
      //tryToScrollY(contentEl, 200);
    }
  }
}
